import api from './api';

export type E2EScenarioMeta = { id: string; group: string; name: string };

export type E2ERunStatus = 'running' | 'passed' | 'failed' | 'aborted';
export type E2EScenarioStatus = 'pass' | 'fail' | 'skip';

export interface E2ERun {
  id: string;
  startedAt: string;
  finishedAt: string | null;
  status: E2ERunStatus;
  passCount: number;
  failCount: number;
  skipCount: number;
  totalScenarios: number;
  durationMs: number | null;
  triggeredBy: number;
  appVersion: string | null;
  notes: string | null;
}

export interface E2EScenarioResultRow {
  id: string;
  runId: string;
  scenarioId: string;
  groupKey: string;
  ord: number;
  status: E2EScenarioStatus;
  durationMs: number;
  failureReason: string | null;
  stepsLog: Array<{ ts: number; level: 'info' | 'warn' | 'error'; message: string }>;
  startedAt: string;
  finishedAt: string;
}

type Envelope<T> = { success: boolean; data: T };

class E2ETestService {
  async listScenarios(): Promise<E2EScenarioMeta[]> {
    const r = await api.get<Envelope<E2EScenarioMeta[]>>('/e2e/scenarios', { headers: { _suppressToast: 'true' } });
    return r.data?.data || [];
  }

  async startRun(): Promise<{ runId: string; totalScenarios: number }> {
    const r = await api.post<Envelope<{ runId: string; totalScenarios: number }>>('/e2e/run');
    return r.data?.data;
  }

  async listRuns(): Promise<E2ERun[]> {
    const r = await api.get<Envelope<E2ERun[]>>('/e2e/runs');
    return r.data?.data || [];
  }

  async getRun(runId: string): Promise<{ run: E2ERun; scenarios: E2EScenarioResultRow[] }> {
    const r = await api.get<Envelope<{ run: E2ERun; scenarios: E2EScenarioResultRow[] }>>(`/e2e/runs/${runId}`);
    return r.data?.data;
  }

  async prune(): Promise<number> {
    const r = await api.post<Envelope<{ deleted: number }>>('/e2e/prune');
    return r.data?.data?.deleted ?? 0;
  }
}

export const e2eTestService = new E2ETestService();
